import store from "./store/store";
import api from "./api/api";
import mutations from "./store/mutations";

let storeLoader = function () {

    const load = function () {
        let sites = [];
        store.commit(mutations.IS_SYNCHRONIZING, true);
        store.commit(mutations.SAVE_SITES, []);
        api.getSites().then(async sitesResponse => {
            sites = sitesResponse.sites;
            let silosPromises = [];
            sites.forEach(site => {
                site.name = site.nombre;
                site.silos = [];
                let promise = api.getSilos(site.id).then(siteResponse => {
                    siteResponse.silos.forEach(silo => {
                        silo.siteId = site.id;
                        silo.siteName = site.nombre;
                        silo.name = silo.nombre;
                        if (silo.position === undefined
                            || silo.position.lat === undefined
                            || silo.position.long === undefined
                            || silo.position.lat === "undefined"
                            || silo.position.long === "undefined"
                            || silo.position.lat === ""
                            || silo.position.long === "") {

                            silo.position = site.position;
                        }
                        site.silos.push(silo);
                    });
                }).catch(reason => {
                    console.error("Fallo la la bsuqueda de silos para el sitio ", site.nombre, reason);
                });
                silosPromises.push(promise);
            });
            await Promise.all(silosPromises).catch(reason => {
                console.error("Fallo una request al buscar silos", reason);
            });

            let allSilos = sites.map(site => {
                return site.silos;
            }).flat();

            /*let i, j, tempArray, chunk = 25;
            for (i = 0, j = allSilos.length; i < j; i += chunk) {
                tempArray = allSilos.slice(i, i + chunk);
                let promises = [];
                tempArray.forEach(silo => {
                    let promise = api.getSilo(silo.siteId, silo.id).then(value => {
                        Object.assign(silo, value.silo);
                        if (silo.sections !== undefined) {
                            silo.sections.forEach(section => {
                                section.siloId = silo.id;
                                section.siloName = silo.name;
                                section.siteId = silo.siteId;
                                section.siteName = silo.siteName;
                            })
                        }
                    }).catch(reason => {
                        console.error("Error al cargar silos", reason);
                    });
                    promises.push(promise)
                });
                await Promise.all(promises).catch(reason => {
                    console.error("Fallo algo en el storeloader", reason);
                })
            }
            */
           
            store.commit(mutations.SAVE_SITES, sites);
            store.commit(mutations.IS_SYNCHRONIZING, false);
        });
    };


    return {
        load: load
    }
}();

export default storeLoader;
